var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ImageLoader-container"},[(!_vm.everythingLoaded)?_c('img',{staticClass:"ImageLoader-placeholder",attrs:{"src":_vm.placeholder}}):_vm._e(),_c('img',{style:({
      transition: `opacity ${_vm.duration}ms`,
      opacity: _vm.loaded ? 1 : 0,
    }),attrs:{"src":_vm.src},on:{"load":_vm.handleLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }